module.exports = __webpack_public_path__ + "media/images/resource/smallZagat-4eeab56027bbdaba15a4daabe5ab62cb.png";